export default "__VITE_ASSET__DLqCXojc__"